import { SourceDataFormStatus } from "@/api/dtos";

const sourceDataFormStatusToText = (status?: SourceDataFormStatus) => {
    switch (status) {
        case SourceDataFormStatus.Complete:
            return 'Complete';
        case SourceDataFormStatus.Started:
            return 'Started';
        case SourceDataFormStatus.None:
        default:
            return 'Not Started'
    }
}

export default sourceDataFormStatusToText;